<ion-header class="ion-no-border">
  <ion-toolbar>
    @if (step !== 'type' && step !== 'done' && !(step === 'plan' && typeLocked)) {
    <ion-buttons slot="start">
      <ion-button fill="clear" (click)="goBack()">
        <ion-icon slot="icon-only" name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    }
    <ion-title>Create Order</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="dismiss()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="page-pad">


    @switch (step) {

    @case ('type') {
    <p class="step-title ps-2">Plan type</p>
    <div class="choice-list">
      <button type="button" class="choice-card" (click)="selectType(PlanType.primary)">
        <div class="choice-main">
          <span class="choice-name">Subscription</span>
        </div>
        <ion-icon name="chevron-forward-outline"></ion-icon>
      </button>
      <button type="button" class="choice-card" (click)="selectType(PlanType.addon)">
        <div class="choice-main">
          <span class="choice-name">Add-On</span>
        </div>
        <ion-icon name="chevron-forward-outline"></ion-icon>
      </button>
    </div>
    }

    @case ('plan') {
    <p class="step-title ps-2">Select plan</p>
    @if (publicPlans.length) {

    <div class="choice-list">
      @for (plan of publicPlans; track plan._id) {
      <button type="button" class="choice-card" (click)="selectPlan(plan)">
        <div class="choice-main">
          <span class="choice-name">{{ plan.name }}</span>
        </div>
        <ion-icon name="chevron-forward-outline"></ion-icon>
      </button>
      }
    </div>
    }
    @if (otherPlans.length) {
    <p class="section-label text-gray-500" [class.section-label-spaced]="publicPlans.length">Custom Plans</p>
    <div class="choice-list">
      @for (plan of otherPlans; track plan._id) {
      <button type="button" class="choice-card" (click)="selectPlan(plan)">
        <div class="choice-main">
          <span class="choice-name">{{ plan.name }}</span>
        </div>
        <ion-icon name="chevron-forward-outline"></ion-icon>
      </button>
      }
    </div>
    }
    @if (!publicPlans.length && !otherPlans.length) {
    <p class="empty-note">No {{ selectedType }} plans found</p>
    }
    }

    @case ('pricing') {
    <p class="step-title ps-2">Select pricing</p>
    <p class="ps-2 mb-4 text-lg">{{ selectedPlan?.name }}</p>
    <div class="choice-list">
      @for (pricing of selectedPlan?.planPricingModels || []; track pricing.name) {
      <button type="button" class="choice-card choice-card-pricing" (click)="selectPricing(pricing)">
        <div class="choice-main">
          <div class="pricing-row">
            <span class="choice-name">{{ pricing.name }}</span>
            <span class="choice-price">₹{{ pricing.amount | number : '1.0-2' }}</span>
          </div>
          @if (pricing.validityDays) {
          <span class="choice-sub">{{ pricing.validityDays }} days</span>
          }
          @if (pricing.discountAmount) {
          <span class="choice-sub">Discount ₹{{ pricing.discountAmount | number : '1.0-2' }}</span>
          }
        </div>
        <ion-icon name="chevron-forward-outline"></ion-icon>
      </button>
      } @empty {
      <p class="empty-note">No pricing models on this plan</p>
      }
    </div>
    }

    @case ('summary') {
    <p class="step-title ps-2">Order summary</p>

    <div class="summary-card">
      <div class="cart-item cart-item-solo">
        <div class="item-info">
          <p class="item-name">{{ selectedPlan?.name }}</p>
          <p class="item-sub">
            {{ selectedType === PlanType.primary ? 'Subscription' : 'Add-On' }}
            · {{ selectedPricing?.name }}
          </p>
        </div>
        <p class="item-price">₹{{ selectedPricing?.amount | number : '1.0-2' }}</p>
      </div>

      @if (priceBreakup; as breakup) {
      <div class="cart-totals">
        <div class="total-row">
          <span>Subtotal</span>
          <span>₹{{ breakup.subtotal | number : '1.0-2' }}</span>
        </div>
        @if (breakup.discountAmount) {
        <div class="total-row muted">
          <span>Discount</span>
          <span>- ₹{{ breakup.discountAmount | number : '1.0-2' }}</span>
        </div>
        }
        <div class="total-row muted">
          <span>GST (18%)</span>
          <span>₹{{ breakup.taxAmount | number : '1.0-2' }}</span>
        </div>
        <div class="total-row total-row-final">
          <span>Total</span>
          <span>₹{{ breakup.payableAmount | number : '1.0-2' }}</span>
        </div>
      </div>
      }
    </div>

    <div class="discount-card">
      <div class="discount-card-header">
        <p class="discount-card-title">Discount</p>
        @if (adminDiscountAmount) {
        <p class="discount-card-sub">- ₹{{ adminDiscountAmount | number : '1.0-2' }}</p>
        }
      </div>
      <div class="discount-input-wrap">
        <input class="discount-input" type="number" min="0" [attr.max]="discountMode === 'percent' ? 100 : null"
          step="0.01" placeholder="{{ discountMode === 'percent' ? '0' : '0.00' }}" [(ngModel)]="discountInput" />
        <div class="discount-mode-segment" role="group" aria-label="Discount type">
          <button type="button" class="discount-mode-btn" [class.active]="discountMode === 'amount'"
            (click)="discountMode = 'amount'" aria-label="Amount in rupees">₹</button>
          <button type="button" class="discount-mode-btn" [class.active]="discountMode === 'percent'"
            (click)="discountMode = 'percent'" aria-label="Percent">%</button>
        </div>
      </div>
    </div>

    <ion-accordion-group class="billing-accordion">
      <ion-accordion value="billing">
        <ion-item slot="header" lines="none" button detail="true" class="billing-accordion-header">
          <ion-label>Billing details</ion-label>
        </ion-item>
        <div slot="content" class="billing-accordion-content">
          <label class="billing-field">
            <span class="billing-label">Billing name</span>
            <input class="billing-input" type="text" placeholder="Organisation / billing name"
              [(ngModel)]="billingName" maxlength="100" autocomplete="organization" />
          </label>

          <label class="billing-field">
            <span class="billing-label">Street address</span>
            <input class="billing-input" type="text" placeholder="Street address"
              [(ngModel)]="addressLine" maxlength="200" autocomplete="street-address" />
          </label>

          <label class="billing-field">
            <span class="billing-label">Pincode</span>
            <input class="billing-input" type="tel" placeholder="6-digit pincode"
              [(ngModel)]="zipCode" maxlength="6" inputmode="numeric" autocomplete="postal-code"
              [class.invalid]="zipCodeInvalid" />
            @if (zipCodeInvalid) {
            <span class="billing-error">Pincode must be 6 digits</span>
            }
          </label>

          <div class="billing-row">
            <label class="billing-field">
              <span class="billing-label">City</span>
              <input class="billing-input" type="text" placeholder="City"
                [(ngModel)]="city" maxlength="50" autocomplete="address-level2" />
            </label>
            <label class="billing-field">
              <span class="billing-label">State</span>
              <input class="billing-input" type="text" placeholder="State"
                [(ngModel)]="state" maxlength="50" autocomplete="address-level1" />
            </label>
          </div>

          <label class="billing-field">
            <span class="billing-label">Country</span>
            <input class="billing-input" type="text" placeholder="Country"
              [(ngModel)]="country" maxlength="50" autocomplete="country-name" />
          </label>

          <label class="billing-field">
            <span class="billing-label">GSTIN</span>
            <input class="billing-input" type="text" placeholder="Optional GSTIN"
              [(ngModel)]="gstin" maxlength="15" autocomplete="off"
              [class.invalid]="gstinInvalid" />
            @if (gstinInvalid) {
            <span class="billing-error">GSTIN format is invalid</span>
            }
          </label>
        </div>
      </ion-accordion>
    </ion-accordion-group>

    <div class="discount-card autorenew-card">
      <div class="autorenew-row">
        <div>
          <p class="discount-card-title">Auto-renew</p>
          @if (autoRenews) {
          <p class="discount-card-sub">Only Razorpay subscription supports auto-renew</p>
          }
        </div>
        <ion-toggle color="dark" [ngModel]="autoRenews" (ngModelChange)="onAutoRenewsChange($event)">
        </ion-toggle>
      </div>
    </div>

    <div class="payment-section">
      <app-payment-method-selector [(value)]="selectedPaymentMethod"
        [exclude]="paymentMethodExclude"></app-payment-method-selector>
    </div>

    <div class="actions">
      <super-button type="fill" background="dark" color="light" [action]="createOrder">
        Create order
      </super-button>
    </div>
    }

    @case ('done') {
    <div class="flex flex-col items-center justify-center ms-2 gap-2 mb-4">

      <ion-icon name="checkmark-circle" class="text-zinc-800 text-[60px]"></ion-icon>
      <p class="text-2xl">Order created</p>

    </div>
    <div class="summary-card done-card">
      <p class="done-copy">
        @if (selectedPaymentMethod === PaymentMethod.RAZORPAY_SUBSCRIPTION) {
        Razorpay subscription link is ready. Share it with the client to complete payment. This will auto-renew.
        } @else {
        Razorpay payment link is ready. Share it with the client to complete payment. This is a one-time payment and will not auto-renew.
        }
      </p>
      <p class="payment-link">{{ paymentLink }}</p>
    </div>
    <div class="actions">
      <super-button type="outline" background="light" iconStart="copy-outline" (click)="copyLink()" textAlign="start">
        Copy payment link
      </super-button>
      <super-button type="outline" background="light" iconStart="mail-outline" iconEnd="paper-plane-outline"
        textAlign="start" [action]="sendPaymentEmail">
        Send email
      </super-button>
    </div>
    }

    }

  </div>
</ion-content>